/* global Content */
import { useStaticQuery, graphql } from 'gatsby';
import { getImage, GatsbyImage, withArtDirection } from 'gatsby-plugin-image';
import * as React from 'react';

interface ImageProps {
	image: Content.ImageObject;
	className?: string;
	imgClassName?: string;
}

export const Image: React.FunctionComponent<ImageProps> = ({ image, className, imgClassName }) => {
	const files = useStaticQuery(graphql`
		query {
			desktop: allFile {
				edges {
					node {
						name
						childImageSharp{
							gatsbyImageData(layout: CONSTRAINED, aspectRatio: 0.5)
						}
					}
				}
			},
			mobile: allFile {
				edges {
					node {
						name
						childImageSharp{
							gatsbyImageData(layout: CONSTRAINED, aspectRatio: 1)
						}
					}
				}
			}
		}
	`);
	const imageData = {
		desktop: getImageByName(files.desktop, image.imageName),
		mobile: getImageByName(files.mobile, image.imageName)
	};
	const source = (imageData.desktop && imageData.mobile) && withArtDirection(imageData.desktop, [
		{
			media: '(max-width: 767px)',
			image: imageData.mobile
		}
	]);

	if (!source) {
		throw new Error('This Image does not exist!');
	}

	return <GatsbyImage className={className} imgClassName={imgClassName} image={source} alt={image.altText ?? ''} />;
};

function getImageByName (files: any, name: string) {
	return getImage(files.edges.find((imageEntry: any) => imageEntry.node.name === name).node);
}
